import React, {Component} from 'react';
import {Card, CardTitle, CardBody, Progress, Input, Label, FormGroup, Table, Alert} from 'reactstrap';

import ProblemDetailsBreadcrumb from '../breadcrumbs/ProblemDetailsBreadcrumb'

import validate from '../validate';
import {graderData, matcherData, serverPath} from '../common';
import axios from "axios";

// /p/courses/:courseId/topic/:topicId/problem/:problemId/edit
// /p/courses/:courseId/topic/:topicId/problem/new

class AddOrUpdateProblem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            topicName: "",
            courseName: "",
            topicId: 0,
            courseId: 0,
            currentStep: 1,
            step1: {
                name: {
                    value: '',
                    placeholder: 'Unesite naslov zadatka.',
                    valid: false,
                    validationRules: {
                        minLength: 3,
                        maxLength: 60,
                        isRequired: true
                    },
                    touched: false
                },
                text: {
                    value: '',
                    placeholder: 'Za unos teksta zadatka mozete koristiti md format.',
                    valid: false,
                    validationRules: {
                        isRequired: true
                    },
                    touched: false
                },
                timeLimit: {
                    value: 100,
                    valid: true,
                    validationRules: {
                        minValue: 1,
                        maxValue: 10000,
                        isRequired: true
                    },
                    touched: false
                },
                memoryLimit: {
                    value: 33554432,
                    valid: true,
                    validationRules: {
                        minValue: 1,
                        maxValue: 268435456,
                        isRequired: true
                    },
                    touched: false
                },
                topic: {
                    value: null,
                    valid: false,
                    validationRules: { },
                    touched: false
                },
                index: {
                    value: 0,
                    valid: false,
                    validationRules: {
                        minValue: 1,
                        isRequired: true
                    },
                    touched: false
                }
            },
            step2: {
                graders: {
                    value: new Map(),
                    valid: false,
                    validationRules: {
                        isRequired: true
                    },
                    touched: false
                },
                matcher: {
                    value: "IgnoreRegexMatcher",
                    valid: true,
                    validationRules: {
                        isRequired: true
                    },
                    touched: false
                },
                matcherArg: {
                    value: "\\s+",
                    valid: true,
                    touched: false
                }
            },
            step3: {
                testCases: []
            },
            step4: {
                solution: null,
                solutionDetails: null
            }
        }
    }

    componentDidMount(){
        axios.get(serverPath + "professorService.php", {
            params: {
                action: 'getBreadcrumbData',
                topicId: this.props.match.params.topicId
            }
        }).then((response) =>{
            this.setState({
                topicName   : response.data.topicName,
                courseName  : response.data.courseName,
                topicId: this.props.match.params.topicId,
                courseId: this.props.match.params.courseId
            });
        });
    }

    handleBlur = event => {
        const {name, value} = event.target;
        const {currentStep} = this.state;

        let valid = false;
        switch(currentStep) {
            case 1:
                valid = this.state.step1[name].valid;
                break;
            case 2:
                valid = this.state.step2[name].valid;
                break;
            case 3:
                valid = this.state.step3[name].valid;
                break;
            case 4:
                valid = this.state.step4[name].valid;
                break;
            default:
                valid = false;
                break;
        }

        if (!valid)
            event.target.className = "form-control invalid-input";
        else
            event.target.className = "form-control";
    }

    handleChange = event => {
        const {name, value} = event.target

        const updatedControls = {
            ...this.state.step1
        };

        const updatedFormElement = {
            ...updatedControls[name]
        };

        updatedFormElement.value = value;
        updatedFormElement.touched = true;
        updatedFormElement.valid = validate(value, updatedFormElement.validationRules);
        if(updatedFormElement.valid)
            event.target.className = "form-control";

        updatedControls[name] = updatedFormElement;

        let formIsValid = true;

        for (let inputIdentifier in updatedControls) {
            formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
        }

        this.setState({
            step1: updatedControls,
            formIsValid: formIsValid
        });
    }

    common_handleChange = (event, updatedControls) => {
        const {name, value} = event.target

        const updatedFormElement = {
            ...updatedControls[name]
        };

        updatedFormElement.value = value;
        updatedFormElement.touched = true;
        updatedFormElement.valid = validate(value, updatedFormElement.validationRules);
        if(updatedFormElement.valid)
            event.target.className = "form-control";

        updatedControls[name] = updatedFormElement;

        let formIsValid = true;

        for (let inputIdentifier in updatedControls) {
            formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
        }

        return formIsValid;
    }

    step2_handleChange = event => {
        if(event.target.type === "checkbox") {
            let item = event.target.name;
            let isChecked = event.target.checked;
            let flags = graderData.find(function(el) {
                return el.name === item;
            }).defaultFlags;

            if(isChecked) {
                this.setState(prevState => ({
                    step2: {
                        ...prevState.step2,
                        graders: {
                            ...prevState.graders,
                            value: prevState.step2.graders.value.set(item, flags)
                        }
                    }
                }));
            } else {
                let graderMap = this.state.step2.graders;
                graderMap.value.delete(item);

                this.setState(prevState => ({
                    step2: {
                        ...prevState.step2,
                        graders: graderMap
                    }
                }));
            }
        } else if (event.target.id.startsWith("flags")) {
            let item = event.target.name;
            let flags = event.target.value;
            let graderMap = this.state.step2.graders;
            graderMap.value.set(item, flags);
            this.setState(prevState => ({
                step2: {
                    ...prevState.step2,
                    graders: graderMap
                }
            }));
        }
        else if (event.target.type === "select-one") {
            let matcherName = event.target.value;
            let arg = matcherData.find(function(el) {
                return el.name === matcherName;
            }).defaultArg;
            this.setState(prevState => ({
                step2: {
                    ...prevState.step2,
                    matcher: {
                        ...prevState.matcher,
                        value: matcherName
                    },
                    matcherArg: {
                        ...prevState.matcherArg,
                        value: arg
                    }
                }
            }));
        } else {
            const updatedControls = {
                ...this.state.step2
            };

            let formIsValid = this.common_handleChange(event,  updatedControls);

            this.setState({
                step2: updatedControls,
                formIsValid: formIsValid
            });
        }
    }

    step3_handleChange = event => {
        let newFiles = Array.prototype.slice.call(event.target.files);
        let oldFiles = this.state.step3.testCases;
        let allFiles = oldFiles.concat(newFiles);

        this.setState(prevState => ({
            step3: {
                ...prevState.step3,
                testCases: allFiles
            }
        }));
    }

    step3_deleteFile = index => {
        let newFiles = this.state.step3.testCases;
        newFiles.splice(index,1);

        this.setState(prevState => ({
            step3: {
                ...prevState.step3,
                testCases: newFiles
            }
        }));
    }

    step4_handleChange = event => {
        let solution = event.target.files[0];

        this.setState(prevState => ({
            step4: {
                ...prevState.step4,
                solution: solution
            }
        }));
    }

    handleSubmit = event => {
        event.preventDefault();
        const { step1, step2, step3, step4 } = this.state;

        var formData = new FormData();
        var graderList = [];
        step2.graders.value.forEach(function(value, key) {
            let id = graderData.find((item) => {return key === item.name;}).idGrader;
            graderList = graderList.concat({idGrader: id, name: key, flags: value});
        });

        var fileNum = step3.testCases.length;
        for( var i=0; i<fileNum; i++) {
            formData.append('testCases[]', step3.testCases[i]);
        }

        formData.append('action', 'addProblem');
        formData.append('idProblem', 0);
        formData.append('name', step1.name.value);
        formData.append('text', step1.text.value);
        formData.append('timeLimit', step1.timeLimit.value);
        formData.append('memoryLimit', step1.memoryLimit.value);
        formData.append('index', step1.index.value);
        formData.append('Topic_idTopic', this.props.match.params.topicId);
        formData.append('graderList', JSON.stringify(graderList));
        formData.append('matcher', step2.matcher.value);
        formData.append('matcherArg', step2.matcherArg.value);
        formData.append('solution', step4.solution);

        axios.post(serverPath + "problemsService.php", formData)
            .then((response) => {
                this.setState(prevState => ({
                    step4: {
                        ...prevState.step4,
                        solutionDetails: response.data
                    }
                }));
            });

    }

    _next = () => {
        let currentStep = this.state.currentStep
        currentStep = currentStep >= 3? 4: currentStep + 1
        this.setState({
            currentStep: currentStep
        })
    }

    _prev = () => {
        let currentStep = this.state.currentStep
        currentStep = currentStep <= 1? 1: currentStep - 1
        this.setState({
            currentStep: currentStep
        })
    }

    previousButton() {
        let currentStep = this.state.currentStep;
        if(currentStep !== 1){
            return (
                <button
                    className="btn btn-secondary"
                    type="button" onClick={this._prev}>
                    Vrati se na prethodni korak
                </button>
            )
        }
        return null;
    }

    nextButton(){
        let currentStep = this.state.currentStep;
        if(currentStep < 4){
            return (
                <button
                    className="btn btn-primary float-right"
                    type="button" onClick={this._next}>
                    Predji na sledeći korak
                </button>
            )
        }
        return null;
    }

    render() {
        return (
            <React.Fragment>
                <ProblemDetailsBreadcrumb data={{problemName: this.state.step1.name.value,
                                                courseName: this.state.courseName,
                                                topicName: this.state.topicName,
                                                courseId: this.props.match.params.courseId,
                                                topicId: this.props.match.params.topicId,
                                                userPrefix: 'p'}}/>
                <Card>
                    <CardTitle> Dodavanje novog zadatka ️</CardTitle>
                    <hr/>
                    <CardBody>
                        <form onSubmit={this.handleSubmit}>
                            {/*Rendering the form steps and passing required props.*/}
                            <div className="text-center">{this.state.currentStep}/4</div>
                            <StepperProgress currentStep={this.state.currentStep}/>
                            <hr/>
                            <Step1
                                currentStep={this.state.currentStep}
                                handleChange={this.handleChange}
                                handleBlur = {this.handleBlur}
                                step1={this.state.step1}
                            />
                            <Step2
                                currentStep={this.state.currentStep}
                                handleChange={this.step2_handleChange}
                                step2={this.state.step2}
                            />
                            <Step3
                                currentStep={this.state.currentStep}
                                handleChange={this.step3_handleChange}
                                deleteFile={this.step3_deleteFile}
                                step3={this.state.step3}
                            />
                            <Step4
                                currentStep={this.state.currentStep}
                                handleChange={this.step4_handleChange}
                                step4={this.state.step4}
                            />
                            {this.previousButton()}
                            {this.nextButton()}
                        </form>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

function StepperProgress(props) {
    if(props.currentStep === 1) {
        return (
            <Progress multi>
                <Progress bar value="1" max="4" color="warning">Osnovni podaci</Progress>
                <Progress bar value="1" max="4" color=""> Podesavanja ocenjivača </Progress>
                <Progress bar value="1" max="4" color="">Test primeri</Progress>
                <Progress bar value="1" max="4" color="">Validacija</Progress>
            </Progress>
        );
    } else if(props.currentStep === 2) {
        return (
            <Progress multi>
                <Progress bar value="1" max="4" color="success">Osnovni podaci</Progress>
                <Progress bar value="1" max="4" color="warning"> Podesavanja ocenjivača </Progress>
                <Progress bar value="1" max="4" color="">Test primeri</Progress>
                <Progress bar value="1" max="4" color="">Validacija</Progress>
            </Progress>
        );
    } else if(props.currentStep === 3) {
        return (
            <Progress multi>
                <Progress bar value="1" max="4" color="success">Osnovni podaci</Progress>
                <Progress bar value="1" max="4" color="success"> Podesavanja ocenjivača </Progress>
                <Progress bar value="1" max="4" color="warning">Test primeri</Progress>
                <Progress bar value="1" max="4" color="">Validacija</Progress>

            </Progress>
        );
    } else {
        return (
            <Progress multi>
                <Progress bar value="1" max="4" color="success">Osnovni podaci</Progress>
                <Progress bar value="1" max="4" color="success"> Podesavanja ocenjivača </Progress>
                <Progress bar value="1" max="4" color="success">Test primeri</Progress>
                <Progress bar value="1" max="4" color="warning">Validacija</Progress>
            </Progress>
        );
    }
}

function Step1(props) {
    if (props.currentStep !== 1) {
        return null
    }
    return(
        <React.Fragment>
            <div className="form-group">
                <label htmlFor="name">Naslov zadatka</label>
                <input
                    className="form-control"
                    id="name"
                    name="name"
                    type="text"
                    placeholder={props.step1.name.placeholder}
                    value={props.step1.name.value}
                    onChange={props.handleChange}
                    touched={props.step1.name.touched}
                    valid={props.step1.name.valid}
                    onBlur={props.handleBlur}
                />
            </div>
            <div className="form-group">
                <label htmlFor="text">Tekst zadatka</label>
                <textarea
                    className="form-control"
                    id="text"
                    name="text"
                    rows="6"
                    placeholder={props.step1.text.placeholder}
                    value={props.step1.text.value}
                    onChange={props.handleChange}
                    touched={props.step1.text.touched}
                    valid={props.step1.text.valid}>
                </textarea>
            </div>

            <div className="form-row">
                <div className="form-group col-md-2">
                    <label htmlFor="index">Redni broj zadatka</label>
                    <input className="form-control"
                           id="index"
                           name="index"
                           type="number"
                           value={props.step1.index.value}
                           onChange={props.handleChange}
                           touched={props.step1.index.touched}
                           valid={props.step1.index.valid}
                           onBlur={props.handleBlur}/>
                </div>
                <div className="form-group col-md-2">
                    <label htmlFor="timeLimit">Vremensko ogranicenje</label>
                    <div className="input-group mb-2 mr-sm-2">
                        <input className="form-control"
                               id="timeLimit"
                               name="timeLimit"
                               type="number"
                               value={props.step1.timeLimit.value}
                               onChange={props.handleChange}
                               touched={props.step1.timeLimit.touched}
                               valid={props.step1.timeLimit.valid}
                               onBlur={props.handleBlur}/>
                        <div className="input-group-append">
                            <div className="input-group-text">ms</div>
                        </div>
                    </div>
                </div>
                <div className="form-group col-md-2">
                    <label htmlFor="memoryLimit">Memorijsko ogranicenje</label>
                    <div className="input-group mb-2 mr-sm-2">
                        <input className="form-control"
                               id="memoryLimit"
                               name="memoryLimit"
                               type="number"
                               value={props.step1.memoryLimit.value}
                               onChange={props.handleChange}
                               touched={props.step1.memoryLimit.touched}
                               valid={props.step1.memoryLimit.valid}
                               onBlur={props.handleBlur}/>
                        <div className="input-group-append">
                            <div className="input-group-text">b</div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

function Step2(props) {
    if (props.currentStep !== 2) {
        return null
    }

    var graderListHtml = graderData.map(el=>{
        let flagsValue = props.step2.graders.value.get(el.name);
        if(typeof flagsValue === 'undefined')
            flagsValue = "";

        return (<div className="form-inline mb-1">
            <div className="form-check col-md-2" style={{'justify-content': 'left'}}>
                <input className="form-check-input"
                       type="checkbox"
                       id={"grader" + el.idGrader}
                       name={el.name}
                       onChange={props.handleChange}
                       checked={props.step2.graders.value.has(el.name)}
                />
                <label className="form-check-label" htmlFor={"defaultCheck"+el.idGrader}> {el.name} </label>
            </div>
            <div className="form-group">
                <input className="form-control"
                       id={"flags"+el.name}
                       name={el.name}
                       type="text"
                       value = {flagsValue}
                       onChange={props.handleChange}
                       disabled={!props.step2.graders.value.has(el.name)}/>
            </div>
        </div>);
    });

    var matchersHtml = matcherData.map(el=>{
        return (<option> {el.name} </option>);
    });

    return(
        <React.Fragment>
            <div className="row">
                <div className="form-group col-6">
                    <label> Izaberite ocenjivač i odgovarajuće flegove</label>
                    {graderListHtml}
                </div>
                <div className="form-group col-6">
                    <div className="form-group">
                        <label htmlFor="matcher"> Izaberite način poređenja rezultata</label>
                        <select type="select"
                                name="matcher"
                                id="matcher"
                                onChange={props.handleChange}
                                value={props.step2.matcher.value}
                                className="form-control">
                            {matchersHtml}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="matcherArg"> Argument </label>
                        <input className="form-control"
                               type="text"
                               name="matcherArg"
                               id="matcherArg"
                               value={props.step2.matcherArg.value}
                               onChange={props.handleChange}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

function Step3(props) {
    if (props.currentStep !== 3) {
        return null
    }

    let fileList = props.step3.testCases.map((el, index) => {
        return (<p>
            <span className="fa fa-remove mr-2" onClick={() => props.deleteFile(index)}> </span> | {el.name}
        </p>);
    });

    return(
        <React.Fragment>
            <FormGroup>
                <Label for="fileUpload">Izaberite test primere</Label>
                <Input type="file"
                       name="testCases"
                       id="fileUpload"
                       multiple
                       onChange={props.handleChange}/>
            </FormGroup>
            <FormGroup>
                <Label> Izabrani fajlovi: </Label>
                {fileList}
            </FormGroup>
        </React.Fragment>
    );
}

function Step4(props) {
    if (props.currentStep !== 4) {
        return null
    }

    var testsTable = "";
    if(props.step4.solutionDetails !== null)
    {
        if(props.step4.solutionDetails.state === "finished")
            testsTable = props.step4.solutionDetails.testResults.map( (el, idx) => {
                return <tr>
                    <td> TEST_{idx} </td>
                    <td> {el.output ? "DA" : "NE"} </td>
                    <td> {el.time} ms</td>
                    <td> {el.wall_time} ms</td>
                    <td> {el.memory/1024/1024} MB </td>
                </tr>;
            });
        else
            testsTable = (<tr> <td colSpan={5}> {props.step4.solutionDetails.state} </td></tr>)
    }

    return(
        <React.Fragment>
            <FormGroup>
                <Label for="fileUpload"> Okacite resenje zadatka </Label>
                <Input type="file"
                       name="testCases"
                       id="fileUpload"
                       onChange={props.handleChange}/>
            </FormGroup>
            <button className="btn btn-success btn-block" disabled={props.step4.solution === null}
                    hidden={props.step4.solutionDetails !== null && props.step4.solutionDetails.isCorrect}> Dodaj zadatak </button>
            {
                props.step4.solutionDetails !== null ?
                    <div className="col-8 offset-2">
                        {
                            props.step4.solutionDetails.isCorrect ?
                                <Alert color="success"> Uspešno ste dodali zadatak! </Alert> :
                                <Alert color="danger"> Greška pri dodavanju zadatka. Proverite unete podatke. </Alert>
                        }
                        <Table size="sm" bordered>
                            <thead>
                            <tr>
                                <th> #</th>
                                <th> isCorrect</th>
                                <th> time</th>
                                <th> wall time</th>
                                <th> memory</th>
                            </tr>
                            </thead>
                            <tbody>
                            {testsTable}
                            </tbody>
                        </Table>
                    </div>
                    :
                    <div></div>
            }
        </React.Fragment>
    );
}

export default AddOrUpdateProblem;